import React from 'react';
import PropTypes from 'prop-types';
import { Card, CardContent, Box, Avatar, Typography } from '@mui/material';

const ExpertSelectionCard = ({ avatar, name, positionAndCompany, onClick, isActive }) => (
  <Card
    sx={{
      mt: 1,
      cursor: 'pointer',
      border: isActive ? '3px solid' : '3px solid transparent',
      borderColor: isActive ? 'primary.main' : 'transparent',
      height: '100%',
      borderRadius: '8px',
      boxSizing: 'border-box',
      display: 'flex',
      alignItems: 'center',
    }}
    onClick={onClick}
  >
    <CardContent>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar src={avatar} sx={{ width: '64px', height: '64px', mr: 2 }} />
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h6">{name}</Typography>
          <Typography>{positionAndCompany}</Typography>
        </Box>
      </Box>
    </CardContent>
  </Card>
);

ExpertSelectionCard.propTypes = {
  avatar: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  positionAndCompany: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
};

export default ExpertSelectionCard;
